import type { Clock, IdGenerator } from "../ports/clock";
import type { WeekPlanRepository, WeightRepository } from "../ports/repositories";
import type { CalendarDate } from "../../domain/shared/calendar-date";
import type { WeightLoggingIntent } from "../../domain/check-in/state-machine";
import { assertWeightLoggingAllowed } from "../../domain/check-in/state-machine";
import { createWeightEntry, type WeightEntry } from "../../domain/weight/weight-entry";

export async function logWeight(
  dependencies: {
    readonly weights: WeightRepository;
    readonly weekPlans: WeekPlanRepository;
    readonly clock: Clock;
    readonly ids: IdGenerator;
  },
  input: { readonly date: CalendarDate; readonly kilograms: number; readonly intent?: WeightLoggingIntent },
): Promise<WeightEntry> {
  const plan = await dependencies.weekPlans.getOpen();
  if (!plan) throw new Error("No active week plan");
  assertWeightLoggingAllowed(plan, dependencies.clock.today(), input.date, input.intent);
  const existing = await dependencies.weights.getByDate(input.date);
  const now = dependencies.clock.now();
  const entry = createWeightEntry({
    id: existing?.id ?? dependencies.ids.next(),
    date: input.date,
    kilograms: input.kilograms,
    recordedAt: existing?.recordedAt ?? now,
    updatedAt: now,
  });
  await dependencies.weights.saveForDate(entry);
  return entry;
}
